<template>
    <div class="cont-result-faq margin-general">
        <NuxtLink :to="localPath('/faq')" class="back-link">
            <span data-v-b04161ba="" class="material-symbols-outlined" translate="no">chevron_left</span>
            {{ $t("faq.goback") }}
        </NuxtLink>
        <div class="sub-cont">
          <FaqAccordion>
            <div class="accordeon container movil">
              <div class="content-main-tab">
                  <div class="tab-content">
                    <div class="contet-general">
                      <h4 role="heading" aria-level="1">{{ $t("faq.tab1.title1") }}</h4>
                      <div class="icon-text">
                        <div class="cont-general">
                          <div class="sub-cont">
                            <p class="body-4"><span v-html="formatContent('faq.tab1.text1', $t, localPath)"></span></p>
                            <p class="body-4"><span >{{ $t("faq.tab1.text2") }}</span></p>
                          </div>
                        </div>
                      </div>
                      <div class="icon-text">
                        <div class="cont-icon">
                          <span class="material-symbols-outlined icon" translate="no">info</span>
                        </div>
                        <div class="cont-general">
                          <div class="sub-cont">
                            <p class="body-4"><span >{{ $t("faq.tab1.text3") }}</span></p>
                            <p class="body-4"><span v-html="formatContent('faq.tab1.text4', $t, localPath)"></span></p>
                            <p class="body-4"><span v-html="formatContent('faq.tab1.text5', $t, localPath)"></span></p>
                            <div class="buttons sub-cont">
                              <NuxtLink :to="localPath('/faq/new-user-guide/step-by-step-guide-to-opening-a-live-account-with-tradeview-markets/')">
                                <button class="second-button-medium">{{ $t("faq.tab1.btn") }}</button>
                              </NuxtLink>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </FaqAccordion>
            <div class="accordeon container destock">
                <div class="content-main-tab">
                    <div class="tab-content">
                      <div class="contet-general">
                        <h1>{{ $t("faq.tab1.title1") }}</h1>
                        <div class="icon-text">
                          <div class="cont-general">
                            <div class="sub-cont">
                              <p class="body-4"><span v-html="formatContent('faq.tab1.text1', $t, localPath)"></span></p>
                              <p class="body-4"><span >{{ $t("faq.tab1.text2") }}</span></p>
                            </div>
                          </div>
                        </div>
                        <div class="icon-text">
                          <div class="cont-icon">
                            <span class="material-symbols-outlined icon" translate="no">info</span>
                          </div>
                          <div class="cont-general">
                            <div class="sub-cont">
                              <p class="body-4"><span >{{ $t("faq.tab1.text3") }}</span></p>
                              <p class="body-4"><span v-html="formatContent('faq.tab1.text4', $t, localPath)"></span></p>
                              <p class="body-4"><span v-html="formatContent('faq.tab1.text5', $t, localPath)"></span></p>
                              <div class="buttons sub-cont">
                                <NuxtLink :to="localPath('/faq/new-user-guide/step-by-step-guide-to-opening-a-live-account-with-tradeview-markets/')">
                                  <button class="second-button-medium">{{ $t("faq.tab1.btn") }}</button>
                                </NuxtLink>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 
</template>

<script setup>
const { t, locale } = useI18n();
const route = useRoute();
const localPath = useLocalePath();
import FaqAccordion from '~/components/faq/FaqAccordion.vue'

useFaqSeoMeta("faq.tab1.title1", "faq.tab1.text1");
</script>



